import React, { useEffect } from "react";
import { useState } from "react";
import { isImage, userAvatar } from "../utils";
import { loadUserTalentDocuments } from "../utils/Network";
import Modal from "react-modal";
import UrlEmbed from "./UrlEmbed";

export default function HasUserTalentDocument({ userdocuments , profile, playTriggerClassName = "" }) {
  const [current_document, setCurrentDocument] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  // loadUserTalentDocuments(usertalent.id).then((userTalentDocuments) => {
  //   setUserTalentDocuments(userTalentDocuments);
  //   if(userTalentDocuments!= null && userTalentDocuments.length>0)
  //       setCurrentDocument(userTalentDocuments[0]);
  // });

  useEffect(() => {
    if (userdocuments != null && userdocuments.length > 0)
      setCurrentDocument(userdocuments[0]);
  }, []);

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  return (
    <div>
      {current_document && (
        <>
          <Modal
            closeTimeoutMS={500}
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className="Modal no-scrollbar"
            overlayClassName="Overlay"
          >
            <div class="modal-content ">
              <div class="modal-header">
                <button type="button" class="close" onClick={closeModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title ">
                  {profile && (
                    <>
                    <img src={profile && userAvatar(profile)} alt="" className="pull-left  img-circle width-30 margin-r-10"  />
                  {profile && profile.first_name} {profile && profile.last_name}
                  </>)}
                </h4>
              </div>
              <div class="modal-body text-center">
                {current_document &&
                  current_document.url &&
                  current_document.url !== "undefined" && (
                    <UrlEmbed url={current_document.url} />
                  )}
                {current_document &&
                  (!current_document.url ||
                    current_document.url === "undefined") && (
                    <>
                      {current_document && isImage(current_document.file) && (
                        <img
                          src={current_document && current_document.file}
                          alt=""
                          class="modal-img"
                        />
                      )}
                      {current_document && !isImage(current_document.file) && (
                        <video id="modal_video" className="video" controls>
                          <source
                            src={current_document.file}
                            type="video/mp4"
                          />
                        </video>
                      )}
                    </>
                  )}
              </div>
            </div>
          </Modal>
          <div className={`btn-cm playdocument ${playTriggerClassName}`.trim()} onClick={openModal}>
            <i className="fa fa-video"></i>
          </div>
        </>
      )}
    </div>
  );
}
